// extracted by mini-css-extract-plugin
export default {"base":"base-leKC_","text":"text-rsXxL"};